module.exports = __webpack_public_path__ + "assets/img/star4.85820fe4.webp";